<template>
  <main class="main main--contact main--full-height">
    <div class="contact group group--indent">
      <div class="contact__header">
        <div>
          <h1 
            :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
            class="h1 mt0 mb0">We’re here for you&nbsp;at</h1>
          <h1 
            :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
            class="h1 mt0"><a :href="`tel:${number}`">{{ number }}</a></h1>
          <p class="p">We’ll answer any questions and help you find the right person to talk to. You’ll also be able to cancel or reschedule your conversation.</p>
          <hr class="hr">
        </div>
        <img :src="illustrationImage" alt="" class="contact__img">
      </div>
      <div class="contact__content">
        <h2 
          :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
          class="h2 mt0">Are you in an emergency?</h2>
        <p class="p fw-bold">If you are experiencing a mental health crisis, dial <a class="tdn" href="tel:988">988</a> now.</p>
        <p class="p fw-bold">For all other emergencies, dial <a class="tdn" href="tel:911">911</a>.</p>
        <h2 
          :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
          class="h2 mt" >Need to help someone other than yourself?</h2>
        <p class="p">If you’re a manager and need to know how to best help a troubled employee, please call us at <a class="tdn link" :href="`tel:${number}`">{{ number }}</a>.</p>
        <p class="p"> If a partner, friend, or co-worker needs help, that person will need to register. Share this URL so they can get started.</p>
        <a 
          :href="org.share_url" 
          :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
          class="p tdn fw-bold c-accent ">{{ org.share_url }}</a>
        <div v-if="org.show_international_section">
          <h2 
            :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
            class="h2">Not in the U.S?</h2>
          <p class="p">Find international resources and phone numbers on our <a class="c-accent tdn fw-bold" href="http://www.achievesolutionsglobal.net">international website</a>. Use the company code {{ org.company_code }}.</p>
        </div>
      </div>
    </div>
  </main>
</template>

<script>

import { mapGetters } from 'vuex';

import illustration from 'images/illustrations/contact.png';
// Images
const illustrationImage = illustration;

export default {
  name: 'contact',

  // Data
  data() {
    return {
      illustrationImage,
    };
  },

  computed: {
    ...mapGetters('app', [
      'org',
    ]),

    number() {
      return this.org.phone;
    },

    link() {
      if ( this.org.company_code === 'united airlines' ) return 'https://www.achievesolutions.net/achievesolutions/en/unitedbeaconwellbeing/Home.do';
      if ( this.org.company_code === 'ngc' ) return 'https://www.achievesolutions.net/achievesolutions/en/ngc/Home.do';
      if ( this.org.company_code === 'wex123' ) return 'https://www.achievesolutions.net/achievesolutions/en/beaconwellbeing/Home.do';
      if ( this.org.company_code === 'wellington' ) return 'https://www.achievesolutions.net/achievesolutions/en/wellington/Home.do';
      return false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// Contact.vue?25acf726